import type { PosterElement, PosterResuelto, Formato } from '@postmaker/poster';

/** Foto de utilería para el editor de plantillas (datos de ejemplo en vivo, §5.3). */
function fotoMuestra(texto: string, color: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400"><rect width="400" height="400" rx="28" fill="${color}"/><text x="200" y="215" font-family="Arial" font-size="44" font-weight="bold" fill="#fff" text-anchor="middle">${texto}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

const COLORES = ['#a855f7', '#0ea5e9', '#f59e0b'];

export interface OpcionesMuestra {
  formato: Formato;
  elementos: PosterElement[];
  fondoColor: string | null;
  fondoUrl: string | null;
  fuentes?: PosterResuelto['fuentes'];
  assets?: Record<string, string>;
  /** Logo real de la marca elegida en la vista previa; sin marca, utilería. */
  logoMarcaUrl?: string | null;
}

/** PosterResuelto de utilería: mismo motor, datos falsos (§5.3 "datos de ejemplo en vivo"). */
export function resueltoDeMuestra(opciones: OpcionesMuestra): PosterResuelto {
  return {
    formato: opciones.formato,
    fondo: { color: opciones.fondoColor, imagenUrl: opciones.fondoUrl },
    elementos: opciones.elementos,
    productos: [0, 1, 2].map((i) => ({
      referencia: `REF-${100 + i}`,
      nombre: `Producto de muestra ${i + 1}`,
      imagenUrl: fotoMuestra(`REF-${100 + i}`, COLORES[i]!),
      precio: { ahora: '$35.00', antes: null },
    })),
    logoClienteUrl: fotoMuestra('LOGO', '#334155'),
    logoMarcaUrl: opciones.logoMarcaUrl !== undefined ? opciones.logoMarcaUrl : fotoMuestra('MARCA', '#111225'),
    nombreNegocio: 'Almacén de Muestra',
    contactos: [
      { canal: 'WHATSAPP', valor: '+593 99 123 4567' },
      { canal: 'INSTAGRAM', valor: '@mi.almacen' },
    ],
    textos: {},
    fuentes: opciones.fuentes ?? [],
    assets: opciones.assets ?? {},
  };
}
